( async function( $ ) {
	await import ( 'bootstrap/js/dist/modal' );

	let initBlock = function( section = false ) {

		const $section = section ? $( section ) : $( '.section-our-equipment' );

		$section.each( function() {
			window.app.main.customScrollbarsForSection( this );
		} );

		if ( $section.find( '.js-our-equipment-slider' ).length ) {
			$section.find( '.js-our-equipment-slider' ).each( function() {
				let $slider = $( this );

				if ( $slider[0].swiper ) {
					$slider[0].swiper.destroy( true, true );
				}
				
				let $swiperSlide = $slider.find( '.swiper-slide' );
				let $swiperNavigation = $slider.siblings( '.section-our-equipment__header' );
				let $swiperButtonPrev = $swiperNavigation.find( '.swiper-button-prev' );
				let $swiperButtonNext = $swiperNavigation.find( '.swiper-button-next' );
				let loop = true;
				let customPagination = false;

				$swiperButtonPrev.removeClass( 'swiper-button-lock' );
				$swiperButtonPrev.removeAttr( 'disabled' );
				$swiperButtonNext.removeClass( 'swiper-button-lock' );
				$swiperButtonNext.removeAttr( 'disabled' );


				$swiperButtonPrev.on( 'click', function() {
					  var paginations = document.querySelectorAll( '.swiper-pagination' );
					  
					  function replaceSlash() {
						paginations.forEach( function( pagination ) {
							pagination.innerHTML = pagination.innerHTML.replace( '[SLASH]', '/' );
							pagination.innerHTML = pagination.innerHTML.replace( '[BARRA]', '/' );
						} );
					  }

					  setTimeout( replaceSlash, 50 );
				} );

				$swiperButtonNext.on( 'click', function() {
					  var paginations = document.querySelectorAll( '.swiper-pagination' );
					  
					  function replaceSlash() {
						paginations.forEach( function( pagination ) {
							pagination.innerHTML = pagination.innerHTML.replace( '[SLASH]', '/' );
							pagination.innerHTML = pagination.innerHTML.replace( '[BARRA]', '/' );
						} );
					  }

					  setTimeout( replaceSlash, 50 );
				} );

				const prepareSliderSettings = () => {
					if ( $swiperSlide.length <= 1 && window.matchMedia( 'screen and (max-width: 767px)' ).matches ) {
						loop = false;
						customPagination = true;
					} else if ( $swiperSlide.length <= 2 && window.matchMedia( 'screen and (min-width: 768px)' ).matches ) {
						loop = false;
						customPagination = true;
					} else if ( $swiperSlide.length <= 3 && window.matchMedia( 'screen and (min-width: 1025px)' ).matches ) {
						loop = false;
						customPagination = true;
					}
				};

				const loadSlider = () => {
					prepareSliderSettings();
					
					new Swiper( $slider[0], {
						slidesPerView: 1,
						slidesPerGroup: 1,
						spaceBetween: 0,
						centeredSlides: false,
						loop: loop,
						speed: 400,
						slideToClickedSlide: false,
						a11y: {
							enabled: false
						},
						simulateTouch: false,
						breakpoints: {
							768: {
								slidesPerView: 2,
								spaceBetween: 20,
							},
							1025: {
								spaceBetween: 10,
								slidesPerView: 3,
							},
						},
						navigation: {
							nextEl: $swiperButtonNext[0],
							prevEl: $swiperButtonPrev[0],
						},
						pagination: {
							el: $swiperNavigation.find( '.swiper-pagination' )[0],
							type: 'fraction',
						},
						on: {
							afterInit: function() {
								window.app.swiperPaginationHelper( $swiperNavigation, true );
								
								if ( customPagination ) {
									$swiperNavigation.find( '.swiper-pagination .swiper-pagination-total' ).text( $swiperSlide.length );
								}
							}
						}
					} );					
				};

				window.app.loadVendor( 'Swiper', loadSlider );
			} );
		}

		if ( $section.find( '.js-open-equipment-video' ).length ) {
			$section.find( '.js-open-equipment-video' ).on( 'click', function( e ) {
				e.preventDefault();
				let $button = $( this );
				let $modalParent = $button.parents( '.modal' );

				$modalParent.modal( 'hide' );
			} );
		}
	};

	window.app.loadBlock( initBlock, 'section-our-equipment', '.section-our-equipment' );
} )( jQuery );